import { useState } from "react";
import { useVillageWiseMandaliCountData, useVillageWiseMandaliDetailData } from "../../../API_Master/FetchAPI";
import VillageWiseMandaliCount from "../../../Components/VillageMandali";
// import MandaliDetail from "../../MandaliDetail"; // removed (page deleted)

import "./BhajanMandali.css";
import VillageWiseBhajanMandali from "../../../Components/VillageWiseMandaliDetail";
const mandaliCards = ["govdash-votersCard", "govdash-amountCard", "govdash-labhartiCard3", "govdash-labhartiCard", "govdash-labhartiCard2"];

const ShimmerCard = () => (
  <>
    <div className="row p-3">
      <div className="col-md-6 col-lg-6 w-90">
        <div className="govdash-villageCard-final  ">
          <div className="village-shimmer" style={{ height: "1rem", marginBottom: "0.6rem" }}></div>
          <div className="village-shimmer" style={{ height: "1.7rem" }}></div>
        </div>
      </div>
      <div className="col-md-6 col-lg-6 w-90">
        <div className="govdash-villageCard-final ">
          <div className="village-shimmer" style={{ height: "1rem", marginBottom: "0.6rem" }}></div>
          <div className="village-shimmer" style={{ height: "1.7rem" }}></div>
        </div>
      </div>
    </div>
  </>
);

const BhajanMandali = ({ bhajanMandaliDashboardData, fetchingBhajanMandaliDashboardData }) => {
  const [bhajanMandaliTypeID, setBhajanMandaliTypeID] = useState("");
  const [currBhajanMandaliState, setCurrentBhjanMandaliState] = useState(null);
  const [selectedBhajanMandaliType, setSelectedBhajanMandaliType] = useState({});
  const [selectedVillage, setSelectedVillage] = useState({});
  const [selectedBhajanMandali, setSelectedBhajanmandali] = useState({});

  const { data: villageWiseMandaliCountData, isFetching: fetchingVillageWiseMandaliCountData } = useVillageWiseMandaliCountData(!!bhajanMandaliTypeID, bhajanMandaliTypeID);
  const { data: villageWiseBhajanMandaliData, isFetching: fetchingVillageWiseBhajanMandaliData } = useVillageWiseMandaliDetailData(
    selectedBhajanMandaliType["bhajanMandaliTypeID"] && selectedVillage["VillageID"] ? true : false,
    selectedVillage["VillageID"],
    selectedBhajanMandaliType["bhajanMandaliTypeID"],
  );

  const handleBhajanMandaliTypeClick = (bhajanMandaliType, theme) => {
    console.log("sdfjkldsfjksdfjsdf", bhajanMandaliType);
    setBhajanMandaliTypeID(bhajanMandaliType.BhajanMandaliTypeID);
    setCurrentBhjanMandaliState("villageWiseMandaliCount");
    setSelectedBhajanMandaliType({
      bhajanMandaliType: bhajanMandaliType.BhajanMandaliType,
      // totalCount: bhajanMandaliType.TotalBhajanMandali,
      totalMemberCount: bhajanMandaliType.TotalBhajanMandaliMember,
      totalMandaliCount: bhajanMandaliType.TotalBhajanMandali,
      bhajanMandaliTypeID: bhajanMandaliType.BhajanMandaliTypeID,
      theme: theme,
    });
  };

  const handleBack = () => {
    if (currBhajanMandaliState === "villageWiseMandaliCount") {
      setCurrentBhjanMandaliState(null);
      setBhajanMandaliTypeID(null);
    } else if (currBhajanMandaliState === "villageWiseMandali") {
      setCurrentBhjanMandaliState("villageWiseMandaliCount");
      setSelectedVillage({});
      setSelectedBhajanmandali({});
    }
  };

  const handleNavigateToMainTab = () => {
    setBhajanMandaliTypeID("");
    setCurrentBhjanMandaliState("");
    setSelectedBhajanMandaliType({});
    setSelectedVillage({});
    setSelectedBhajanmandali({});
  };

  console.log("sdfjsdlkfjsdfjsdfaskdlf", selectedBhajanMandaliType);
  return (
    <>
      {fetchingBhajanMandaliDashboardData ? (
        <ShimmerCard />
      ) : (
        <>
          {currBhajanMandaliState && (
            <button
              id="govdash-back-btn"
              className={"govdash-backBtn"}
              onClick={() => {
                handleBack();
              }}
            >
              Back
            </button>
          )}
          {!currBhajanMandaliState && (
            <div className="govdash-summaryGrid  ">
              {bhajanMandaliDashboardData?.map((bhajanMandaliType, i) => {
                const theme = mandaliCards[i % mandaliCards.length];

                return (
                  <div
                    key={bhajanMandaliType.BhajanMandaliTypeID}
                    className={`govdash-summaryCard ${theme}`}
                    onClick={() => handleBhajanMandaliTypeClick(bhajanMandaliType, theme)}
                  >
                    <div className="govdash-cardContent">
                      {/* Left – Icon */}
                      <div className="govdash-cardIconWrap">
                        <i className="fas fa-hands-praying"></i>
                      </div>
                      {/* Right – Content */}
                      <div className="govdash-cardText">
                        {/* BIG COUNT */}
                        {/* <div className="govdash-bigCount">{bhajanMandaliType.TotalBhajanMandali ?? 0}</div> */}
                        <div className="govdash-bigCount">{bhajanMandaliType.TotalBhajanMandali ?? 0}</div>

                        {/* TYPE NAME */}
                        <div className="govdash-cardTitle govdash-bhajanMandaliTitle">{bhajanMandaliType.BhajanMandaliType}</div>

                        {/* SUB META */}
                        <div className="govdash-cardFooter">
                          <span>Village Count</span>
                          <strong>{bhajanMandaliType.TotalVillages ?? 0}</strong> |<span>Member Count</span>
                          <strong>{bhajanMandaliType.TotalBhajanMandaliMember ?? 0}</strong>
                        </div>
                      </div>
                    </div>

                    <div className="govdash-cardBg"></div>
                  </div>
                );
              })}
            </div>
          )}
        </>
      )}
      {bhajanMandaliTypeID && currBhajanMandaliState === "villageWiseMandaliCount" && (
        <VillageWiseMandaliCount
          villageWiseMandaliCountData={villageWiseMandaliCountData}
          fetchingVillageWiseMandaliCountData={fetchingVillageWiseMandaliCountData}
          villageWiseBhajanMandaliData={villageWiseBhajanMandaliData}
          fetchingVillageWiseBhajanMandaliData={fetchingVillageWiseBhajanMandaliData}
          selectedBhajanMandaliType={selectedBhajanMandaliType}
          handleNavigateToMainTab={handleNavigateToMainTab}
          setSelectedVillage={setSelectedVillage}
          setCurrentBhjanMandaliState={setCurrentBhjanMandaliState}
          // bhajanMandaliTypeID={bhajanMandaliTypeID}
          // selectedVillage={selectedVillage}
          // currBhajanMandaliState={currBhajanMandaliState}
        />
      )}

      {selectedVillage && currBhajanMandaliState === "villageWiseMandali" && (
        <VillageWiseBhajanMandali
          villageWiseBhajanMandaliData={villageWiseBhajanMandaliData}
          fetchingVillageWiseBhajanMandaliData={fetchingVillageWiseBhajanMandaliData}
          selectedBhajanMandaliType={selectedBhajanMandaliType}
          handleNavigateToMainTab={handleNavigateToMainTab}
          selectedVillage={selectedVillage}
          selectedBhajanMandali={selectedBhajanMandali}
          setSelectedBhajanmandali={setSelectedBhajanmandali}
        />
      )}

      {/* {selectedVillage && currBhajanMandaliState === "MandaliDetailData" && (
        <MandaliDetail
          selectedVillage={selectedVillage}
          bhajanMandaliTypeID={bhajanMandaliTypeID}
          handleNavigateToMainTab={handleNavigateToMainTab}
          selectedBhajanMandali={selectedBhajanMandali}
        />
      )} */}
    </>
  );
};

export default BhajanMandali;
